import "./SuccessStoriesCarousel.css";
import { SuccessStory } from "./SuccessStoriesSpeakForThemselves";
import SuccessStoryCard, { StartOwnSuccessStory } from "./SuccessStoryCard";

const carouselForMobile = (successStories: SuccessStory[]) => {
  if (successStories.length === 0) {
    return <p>No success stories available at the moment.</p>;
  }

  const slides: JSX.Element[] = [];

  // Loop through each success story
  successStories.forEach((story, idx) => {
    slides.push(
      <div
        className={`carousel-item ${idx === 0 ? "active" : ""}`}
        key={story.id}
      >
        <div className="row">
          <div className="col-12 mb-3">
            <SuccessStoryCard story={story} />
          </div>
        </div>
      </div>
    );
  });

  // Add final CTA slide
  slides.push(
    <div className="carousel-item" key="cta-slide">
      <div className="row">
        <div className="col-12 mb-3">
          <StartOwnSuccessStory />
        </div>
      </div>
    </div>
  );

  return (
    <div
      id="carouselExampleControlsMobile"
      className="carousel slide success-stories-carousel"
      data-bs-ride="carousel"
    >
      <div className="carousel-inner">{slides}</div>

      {/* Controls */}
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleControlsMobile"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselExampleControlsMobile"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default carouselForMobile;
